import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const LeftMenuBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
export const Welcome = styled.div`
  // color: ${themeGet('colors.primary', '#9cc54b')};
  color: #9cc54b;
  &.express {
    color: #f01266;
  }
  .customerName{
    font-size: 20px;
    font-weight: 900;
    margin-bottom: -5px;
    text-transform: capitalize;
  }
  .welcome {
    font-weight: 500;
  }
`
export const MainMenu = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-right: 10px;

  .popover-wrapper {
    .popover-content {
      .menu-item {
        font-family: 'Lato', sans-serif;
        a {
          font-size: 15px;
          font-weight: 700;
          color: ${themeGet('colors.darkBold', '#0D1136')};
          line-height: 1.2em;
          display: block;
          padding: 15px 30px;
          border-radius: 6px;
          transition: 0.15s ease-in-out;
          display: flex;
          align-items: center;
          @media (max-width: 1400px) {
            margin-right: 10px;
            font-size: 15px;
          }

          @media only screen and (min-width: 991px) and (max-width: 1200px) {
            padding: 15px 30px;
          }

          &:hover {
            color: ${themeGet('colors.primary', '#9cc54b')};
          }
          &.current-page {
            color: ${themeGet('colors.primary', '#9cc54b')};
            background-color: #fff;
          }
        }
      }
    }
  }
`;

export const SelectedItem = styled.button`
  width: auto;
  height: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: rgb(0,152,0);
  border: 1px solid rgb(0, 152, 0);
  // padding-top: 10px;
  // padding-bottom: 10px;
  padding-left: ${themeGet('space.4', '0')}px;
  padding-right: ${themeGet('space.4', '0')}px;
  // border-radius: ${themeGet('radius.3', '6')}px;
  outline: 0;
  min-width: 100px;
  cursor: pointer;

  span {
    display: flex;
    align-items: center;
    font-family: 'Lato', sans-serif;
    font-size: ${themeGet('fontSizes.2', '15')}px;
    font-weight: ${themeGet('fontWeights.6', '700')};
    color: ${themeGet('colors.primary', '#9cc54b')};
    text-decoration: none;

    &:first-child {
      margin-right: auto;
    }
  }
`;
export const Icon = styled.div`
  margin-right: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  // height: 25px;
`;
export const Arrow = styled.span`
  width: 12px;
  margin-left: 16px;
`;
